import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import "../Styles/LegalDocs.css";
import { useTranslation } from 'react-i18next';

function LegalDocs() {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'he'; // Check if the current language is Hebrew

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  });

  return (
    <div className={`legal-section-title ${isRTL ? 'rtl' : ''}`}>
      <h1 className="legal-siteTitle">
      <Link to="/">
          Dr.Shada <span className="navbar-sign">Habib</span>
        </Link>
      </h1>

      <div className="legal-text-content">
        <p className="legal-title">{t("generalInfoTitle")}</p>
        <p className="legal-description">
          {t("generalInfoDescription")}
        </p>

        <p className="legal-title">{t("privacyPolicyTitle")}</p>
        <p className="legal-description">
          {t("privacyPolicyDescription")}
        </p>

        <p className="legal-title">{t("termsOfServiceTitle")}</p>
        <p className="legal-description">
          {t("termsOfServiceDescription")}
        </p>

        <p className="legal-title">{t("consultationsTitle")}</p>
        <p className="legal-description">
          {t("consultationsDescription")}
        </p>

        <p className="legal-title">{t("howItWorksTitle")}</p>
        <p className="legal-description">
          {t("howItWorksDescription")}
        </p>
      </div>

      <div className="legal-footer">
        <p style={{ margin: 0 }}>
          <a href="https://www.rr-web.net/" target="_blank" rel="noopener noreferrer" style={{ textDecoration: "none", color: "inherit" }}>
            &copy; 2024 R & R-Net. All rights reserved
          </a>
        </p>
      </div>
    </div>
  );
}

export default LegalDocs;
